import React, { useEffect, useState } from 'react';
import '../App.css';
import Layout from '../components/Layout';

const SmartEducation = () => {
  const [activeSection, setActiveSection] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const contentSections = [
    {
      title: '师资发展管理系统',
      content: '师资发展管理系统基于一体化智慧校园设计，自动汇总相关业务系统中教师的档案数据后进行分类管理，并构建院校师资画像和教师个人画像，以数字结合图像的形式直观展示学校的师资发展情况，为学校领导全方位了解学校教师情况、完善教师管理体系提供可靠依据；此外，系统支持用户线上发布和管理教师招聘与培训计划，助力学校适应教育改革发展；另外，可对接教育局端师资发展管理系统，接受教育局安排的教师素质能力提升研修班等统一培训活动。',
      img: <img src="/src/img/szfzgl.png" alt="" />
    },
    {
      title: '学生成长信息管理系统',
      content: '学生画像（成长）信息管理系统是一个以实现“全程跟踪学生成长动态、全面掌握学生发展结果、全方位展现学生数字画像、服务学生成长成才”为目标的教育管理及个人发展指导平台，涵盖日常作业、课堂表现、考试成绩、学生考勤、学生健康、奖惩情况、成长历程、词云评价等多个功能模块，通过对各项数据的整合、统计及分析，形成学生个人画像、班级画像、群体画像，让师生家长与校领导等用户可随时掌握、跟踪学生成长动态，促进学生德智体美劳全面发展。',
      img: <img src="/src/img/xsczxxgl.png" alt="" />
    },
    {
      title: '校本资源管理系统',
      content: '校本资源管理系统可提供多学科资源库（教材库、经典案例库、精品课件库等）、公共图书馆两大阅览库的管理；系统支持上传学校电子资源（电子教材等），并可对所有资料进行集中管理，统计并分析资源使用和建设情况，指导学校高效建设、更新资源。',
      img: <img src="/src/img/xbzygl.png" alt="" />
    },
    {
      title: '网上课堂',
      content: '网上课堂系统围绕课堂教学资源建立，融合了人工智能、大数据、云计算等技术。通过对接基础平台、数字化档案管理、课堂录播及信息采集、多媒体教学等多个系统，实现了公开课管理、直播管理、移动听课、课后点播等功能。从而为用户提供了资源管理、教学互动等服务，满足了教学资源共享、教学过程可视化、教学效果评估的实际需求。与此同时系统为校方提供了网上课堂数据总览及服务器管理服务，辅助校方实时掌控教室使用率、服务器承载力等重要信息，为校方及时发现并解决问题、合理分配相关资源提供有效依据。',
      img: <img src="/src/img/wskt.png" alt="" />
    },
    {
      title: '教学评价系统',
      content: '教学评价系统是为了促进教育科学发展和提高教师素质而设计的系统。它可以帮助学校管理教务，发布问卷调查，并生成多维度的评价体系。通过评教评学系统，可以获得任课教师的教学质量和学生的反馈，来评估教学质量，促进教学内容和方向的引导，并且可以实时回流到数据中心，用于建设教师综合档案，为教师队伍建设提供指导。',
      img: <img src="/src/img/jxpj.png" alt="" />
    },
    {
      title: '排课管理系统',
      content: '排课系统利用新一代信息技术和智能算法，按照学校的教学需要将自习课、理论课、实训课安排在早上、白天(上午/下午)、晚上3个时段上课，帮助学校编排科学合理的课表，尽量满足课程、教师、教室、时间等层面的条件与限制，为教师、学生和管理者提供课表服务。系统以“步骤条、向导式”的用户界面，引导排课人员使用1套授课安排表、在1天内就能完成排课。系统提供排课参数设置、授课安排管理、排课规则、固定课优先、自动排课、人工微调、课表发布、课表查询、课表导出等功能，满足行政班授课、教学合班授课、多师合师授课、单双周合课授课4种业务场景。',
      img: <img src="/src/img/pkgl.png" alt="" />
    },
    {
      title: '教学督导及巡课系统',
      content: '该系统融合在线巡课、远程督导，支持对教室进行远程教学巡视、查看课堂教学情况，支持移动巡课；同时可设定教学质量评价维度，实现在线/离线督导评课，并自动汇总形成数据记录及统计图表。通过搭建私有云，实现课堂的实时上传及分享，教育局或学校领导通过网络就可以在线对全校的教研活动集中督导，大大缩短教研活动的时间，提高教研活动的效率，提升学校教学质量。',
      img: <img src="/src/img/jxdd.png" alt="" />
    },
    {
      title: '学情分析系统',
      content: '课堂教学（AI）学情分析系统可以监测课堂实时画面呈现、课堂学生行为进行、课堂学生活跃度、历史课堂图片和学情分析报告等方面进行实时分析和统计，真实展现听课的情况，用于课堂的学情分析，有助于教研活动开展和课题研究，提升课堂教学效果。',
      img: <img src="/src/img/xqfx.png" alt="" />
    },
    {
      title: '实习管理系统',
      content: '实习管理系统为学校提供一站式实习管理服务。系统通过一体化的设计与开发，实现了集中、灵活的学生实习管理，提供实习进度跟踪、指导巡查记录管理、考评鉴定、问卷调查及意见反馈等功能，同时根据实习情况进行自动化分类统计与归档，实现对实习学生的动态实时管理，为学校构建了全面的实习跟踪、指导和评价体系。此外，该系统支持实习师生通过微信小程序进行信息互动交流，全面深化实习过程的监督管理服务，确保实习效果与质量的持续提升。',
      img: <img src="/src/img/sxgl.png" alt="" />
    },
    {
      title: '智慧教室',
      content: '多媒体智慧教室是充分应用人工智能技术，构建的多功能智慧教室，具有集成度高、稳定可靠的特点，是实现教学功能多样化、精品课堂资源共享、智慧教室环境现代化、以及智慧教室统一管理的重要手段，是智慧校园的标准教室。',
      img: <img src="/src/img/zhjs.png" alt="" />
    },
    {
      title: '虚拟仿真实训室',
      content: '虚拟防真实训室是一种利用虚拟仿真技术创建的教学实训环境。它具有情境性、交互性、开放性和共享性等特点，可以让学生实现沉浸式学习。虚拟仿真实训室通常会结合相关专业的教学需求，开发基于职场环境与工作过程的虚拟仿真实训资源，以解决传统实训教学中的一些痛点难点，例如高投入、高损耗、高风险及难实施、难观摩、难再现等问题。',
      img: <img src="" alt="" />
    },
    {
      title: '智慧图书馆',
      content: '学校智慧图书馆通过引进现代化设备和RFID技术，部署馆务系统、RFID技术、安全门禁、自助借还书机、智能盘点车、OPAC查询机、馆情数据大屏等系列数字化产品，建立图书馆的数字化服务平台，提供在线检索、电子借阅、学习资源共享等功能，方便师生获取信息和知识。',
      img: <img src="/src/img/zhtsg.png" alt="" />
    }
  ];

  const handleSectionChange = (index) => {
    setActiveSection(index);
  };

  return (
    <Layout>
      <div className="page-header" style={{ 
        backgroundImage: 'url("/src/img/zhmkt.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '300px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '20px'
      }}>
        <h1 style={{ 
          color: '#fff',
          fontSize: '2.5rem',
          fontWeight: 'bold',
          textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
        }}>智慧教育系统</h1>
      </div>
      <div className="page-container">
        <div className="page-layout">
          <div className="left-menu">
            {contentSections.map((section, index) => (
              <div
                key={index}
                className={`menu-item ${activeSection === index ? 'active' : ''}`}
                onClick={() => handleSectionChange(index)}
              >
                {section.title}
              </div>
            ))}
          </div>
          <div className="content-section">
            <div className="section-header" style={{
              padding: '20px 40px',
              marginBottom: '30px'
            }}>
              <h3 style={{
                fontSize: '1.2rem',
                lineHeight: '1.6',
                color: '#333',
                textIndent: '2em'
              }}>{contentSections[activeSection].content}</h3>
            </div>
            <div className="education-content">
              <div className="education-features" style={{ display: 'flex', justifyContent: 'center', height: '500px', marginBottom: '40px' }}>
                <div style={{ width: '1000px', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
                  {contentSections[activeSection].img && React.cloneElement(contentSections[activeSection].img, {
                    style: { width: '100%', height: '100%', objectFit: 'contain' }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SmartEducation;